import { User } from "../../utils/types/user";

export interface SetUserAction {
  type: "SET_USER";
  payload: User;
}

export interface GetUsersAction {
  type: "GET_USERS_SUCCESS" | "GET_USERS_ERROR";
  payload: User[];
}

export interface GetRolesAction {
  type: "GET_ROLES_SUCCESS" | "GET_ROLES_ERROR";
  payload: User[];
}

export const setUser = (user: User): SetUserAction => ({
  type: "SET_USER",
  payload: user,
});

export interface SetUserLogoutAction {
  type: "Log_Out";
  payload: null;
}
export const signOutUser = (): SetUserLogoutAction => ({
  type: "Log_Out",
  payload: null,
});
